/*
 * Copyright (c) 2017.  Bakos Energy (Apeldoorn NL), Spin in het Web (Apeldoorn NL)
 */

/**
 * SPIN IN HET WEB APELDOORN
 * User: Jelmer Jellema
 * Date: 28-5-2017
 * Time: 05:49
 *
 * componenten voor de schermopbouw
 *
 * Is tevens een container voor de states eronder, dus onze scope valt door
 *
 */

angular.module('myApp.schermopbouw', ['sihw.sihwlog', 'dl.api'])
//navbar
    .directive('mainscherm', ['$timeout', 'sihwlog', 'approuter', 'api', function ($timeout, sihwlog, approuter, api) {
        var log = sihwlog.logLevel('debug');
        return {
            //directive definitie
            restrict: 'E',
            //element
            templateUrl: "components/schermopbouw/mainscherm.html",
            scope: true, //overerven
            link: function ($scope, el, attr) {
                log.debug('Init mainscherm');

                $scope.balk = {};
                $scope.zoek = { //apart object, want in een ng-if en alles.
                    zoekterm: "",
                    zoekresultaten: null
                };

                /**
                 * Init het mainscherm
                 */
                function init() {
                    $scope.navheight = 50; //eerst maar eens
                    $(window).on('resize', setMainheight);
                    //en even aan het begin wachten tot mainnav een height heeft. Dat kan even duren,
                    //ivm de gekke laadvolgorde (dom al ready, dan pas template)
                    $(function () {
                        var checkheight = function () {
                            if ($('#mainnav').height()) {
                                setMainheight();
                            }
                            else {
                                $timeout(checkheight, 20);
                            }
                        };
                        checkheight();
                    })


                }

                /**
                 * Bij resize opnieuw genoeg ruimte rond de nav
                 */
                function setMainheight() {
                    $scope.navheight = $('#mainnav').height();
                    $scope.$apply();
                }

                $scope.logout = function() {
                    setZoek(false);
                    $scope.zoek.zoekterm = "";
                    $scope.zoek.zoekresultaten = null; //weg
                    approuter.logout();
                }


                /**
                 * Zet het zoekscherm open (show = true) of dicht (show = false) en regel bodyclass
                 * @param show
                 */
                function setZoek(show) {
                    $scope.zoek.show = show;
                    let body = $('body');
                    if (show)
                    {
                        body.addClass('zoekscherm');
                    }
                    else {
                        body.removeClass('zoekscherm');
                    }
                }

                /**
                 * Open of sluit het zoekscherm
                 */
                $scope.toggleZoek = function() {
                    setZoek(! $scope.zoek.show);
                }



                $scope.clearZoek = function() {
                    $scope.zoek.zoekterm = "";
                    $scope.zoek.zoekresultaten = null;
                    setZoek(false)
                }

                $scope.zoeken = function() {
                    log.debug('zoeken', $scope.zoek);
                    if ($scope.zoek.zoekterm?.length) {
                        $scope.zoek.zoekresultaten = null;
                        setZoek(false);
                        api.zoeken($scope.zoek.zoekterm).then(function(res) {
                            if (res.length) {
                                res.sort((a,b) => {
                                    if (a.domein !== b.domein)
                                    {
                                        return a.domein.localeCompare(b.domein);
                                    }
                                    let apr = a.project || "-";
                                    let bpr = b.project || "-";
                                    if (apr !== bpr)
                                    {
                                        return apr.localeCompare(bpr);
                                    }
                                    let au = a.user || "-";
                                    let bu = b.user || "-";
                                    if (au !== bu)
                                    {
                                        return au.localeCompare(bu);
                                    }
                                    let am = a.model || "-";
                                    let bm = b.model || "-";
                                    return am.localeCompare(bm);
                                });
                                $scope.zoek.zoekresultaten = res;
                                setZoek(true);
                            }
                            else {
                                api.toast("ZOEK.GEEN");
                            }
                        });
                    }
                }

                $scope.routeerZoek = function(rij)
                {
                    log.debug(`Klik resultaat`,rij);
                    setZoek(false);
                    switch(rij.type)
                    {
                        case 'domein':
                            approuter.go('domein',{domein: rij.domeinid});
                            break;
                        case 'project':
                        case 'projectuser': //die kan ook alleen naar het project
                        case 'model': //idem. Misschien apart laten op zoeken?
                            approuter.go('project',{
                                project: rij.projectid
                            });
                            break;
                        case 'user':
                            approuter.go('gebruiker', {
                                gebruiker: rij.userid
                            });
                            break;
                    }
                }

                init();
            }
        }
    }]);
